// Ported from the Polaris kit: src/product/components/initials.js.
// "Alex Morgan" -> "AM". At most two letters, so avatars stay legible at 32px.
export const initials = name =>
  name
    .trim()
    .split(/\s+/)
    .map(part => part[0])
    .slice(0, 2)
    .join('')
    .toUpperCase();
